import { truncate } from "lodash";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { CommandItem } from "cmdk";

import { Reader } from "@/features/system/types";

import { ROUTES } from "@/constants/routes";
type Props = {
  reader: Reader;
  onSelect?: (to: string) => void;
  query?: string;
};
export const SearchItemReader = ({
  reader,
  onSelect = () => {},
  query = "",
}: Props) => {
  const to = `${ROUTES.READERS}/${reader.readerId}`;

  return (
    <CommandItem
      data-testid="search-item"
      onSelect={() => onSelect(to)}
      className="group relative cursor-pointer select-none items-center bg-white px-3 py-[2px] text-sm outline-none first:before:block first:before:h-[12px] first:before:w-full first:before:content-[''] last:after:block last:after:h-[12px] last:after:w-full last:after:content-['']   data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50 [&:not(:last-child)]:mb-2 "
    >
      <Link
        to={to}
        className="flex h-full min-h-[56px] items-start rounded-md py-[7px] pl-3 pr-2 group-aria-selected:bg-[#F8FAFC]"
      >
        <div className="flex-1 overflow-hidden">
          <div className="mb-1 flex items-center justify-between font-sora text-sm font-medium tracking-[-0.003em] text-chorus-black-200">
            <Highlighter
              highlightClassName="bg-chorus-teal-100 rounded-[2px] text-chorus-black-100"
              searchWords={query?.split(" ")}
              autoEscape={true}
              textToHighlight={truncate(reader.readerId, { length: 40 })}
            />
          </div>
        </div>
      </Link>
    </CommandItem>
  );
};
